import React, { useEffect, useRef } from 'react';
import { resumeBgm } from '../utils/bgm';

/**
 * Video Player Component
 * @param {string} videoUrl - Video URL or source
 * @param {string} posterImage - Poster/thumbnail image URL
 * @param {number} seekTo - (optional) Seek to this time (in seconds) when changed
 */
const VideoPlayer = ({
    videoUrl,
    posterImage = '',
    autoPlay = false,
    showControls = true,
    isPlaying = true,
    muted = false,
    onLoadedMetadata,
    seekTo,
    preload = 'auto',
    style = {},
}) => {
    const videoRef = useRef(null);

    //console.log('VideoPlayer rendered with seekTo:', seekTo, ' isPlaying:', isPlaying);

    // Only update seek if difference is > 1s
    useEffect(() => {
        const videoElement = videoRef.current;
        //console.log('VideoPlayer - seekTo changed1:', videoRef.current);
        //console.log('VideoPlayer - seekTo changed2:', videoRef.currentTime);
        //console.log('VideoPlayer - videoElement changed3:', videoElement);
        //console.log('VideoPlayer - videoElement.currentTime changed3:', videoElement?.currentTime);
        //console.log('VideoPlayer - videoElement.readyState changed3:', videoElement?.readyState);
        //console.log('VideoPlayer - seekTo changed3:', seekTo);
        if (!videoElement || typeof seekTo !== 'number' || isNaN(seekTo)) return;
        // Only seek if video is loaded and seekTo is valid
        if (videoElement.readyState >= 1) {
            //console.log('VideoPlayer - seekTo changed3 =>>>>>>>>>>> 1');
            if (Math.abs(videoElement.currentTime - seekTo) > 0.5) {
                videoElement.currentTime = seekTo;
            }
        } else {
            //console.log('VideoPlayer - seekTo changed3 =>>>>>>>>>>> 2');
            // If not loaded, wait for loadedmetadata
            const handleLoaded = () => {
                if (Math.abs(videoElement.currentTime - seekTo) > 1) {
                    videoElement.currentTime = seekTo;
                }
            };
            videoElement.addEventListener('loadedmetadata', handleLoaded, { once: true });
            return () => videoElement.removeEventListener('loadedmetadata', handleLoaded);
        }
    }, [seekTo, videoUrl]);

    useEffect(() => {
        const videoElement = videoRef.current;
        if (!videoElement) return;
        if (isPlaying) {
            const playPromise = videoElement.play();
            if (playPromise?.catch) {
                playPromise.catch((err) => {
                    console.warn('Video failed to play automatically:', err?.message);
                });
            }
            resumeBgm();
        } else {
            videoElement.pause();
        }
    }, [isPlaying, videoUrl]);

    //Listen for loadedmetadata to get duration
    useEffect(() => {
        const videoElement = videoRef.current;
        if (!videoElement || !onLoadedMetadata) return;
        const handleLoadedMetadata = () => {
            onLoadedMetadata(videoElement.duration);
        };
        videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
        return () => {
            videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
        };
    }, [onLoadedMetadata, videoUrl]);

    return (
        <div style={{
            width: '100%',
            height: '100%',
            backgroundColor: '#000000',
            borderRadius: '8px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            ...style,
        }}>
            {videoUrl ? (
                <video
                    ref={videoRef}
                    src={videoUrl}
                    poster={posterImage}
                    controls={showControls}
                    autoPlay={autoPlay}
                    muted={muted}
                    playsInline
                    preload={preload}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        pointerEvents: 'none',
                    }}
                />
            ) : null}
        </div>
    );
};

export default VideoPlayer;

